import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/orden_trabajo/getOrdenTrabajo.php';

export default function getOrdenTrabajo({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}